import { useI18n } from 'core/i18n/I18nProvider';
import { Badge } from 'shared/components/Feedback';

export function SpecialistStatusBadge({ isActive }) {
  const { t } = useI18n();

  if (isActive === true) {
    return <Badge tone="success">{t('specialists.active')}</Badge>;
  }
  if (isActive === false) {
    return <Badge>{t('specialists.inactive')}</Badge>;
  }
  return <Badge tone="warning">{t('specialists.statusUnknown')}</Badge>;
}

export function specialistActivationActionLabel(isActive, t) {
  if (isActive === true) {
    return t('actions.deactivate');
  }
  if (isActive === false) {
    return t('actions.activate');
  }
  return t('specialists.statusUnknown');
}
